<template>
    <div>
        <h3>Not Authorized</h3>
        <p>You are not authorized to view this page. Please contact a site admin if you believe this to be an error.</p>
    </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>
